import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const services = [{
  title: 'Весілля',
  description: 'Повна організація весілля вашої мрії. Від розробки унікальної концепції до координації в день заходу.',
  price: 'Вартість від $5,000',
  img: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=2070&auto=format&fit=crop'
}, {
  title: 'Корпоративні події',
  description: 'Масштабні святкування, тімбілдінги та ювілеї компаній, що підкреслюють статус та цінності вашого бренду.',
  price: 'Вартість від $10,000',
  img: 'https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=2069&auto=format&fit=crop'
}, {
  title: 'Приватні вечірки',
  description: 'Ексклюзивні дні народження та закриті заходи з унікальною концепцією та найвищим рівнем приватності.',
  price: 'Вартість від $3,000',
  img: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=2070&auto=format&fit=crop'
}];
export function Services() {
  return <section id="services" className="py-24 bg-surface" data-id="element-136">
      <div className="max-w-7xl mx-auto px-6" data-id="element-137">
        <div className="text-center max-w-2xl mx-auto mb-20" data-id="element-138">
          <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-139">
            Наші послуги
          </h2>
          <p className="text-secondary text-lg" data-id="element-140">
            Оберіть формат вашої події. Ми пропонуємо прозоре ціноутворення та
            преміальний підхід до кожної задачі.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-141">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-background rounded-3xl border border-border overflow-hidden hover:border-primary/50 transition-colors duration-300 flex flex-col" data-id="element-142">
              <div className="h-64 overflow-hidden relative" data-id="element-143">
                <img src={service.img} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-144" />
                {/* Высококонтрастная плашка цены */}
                <div className="absolute top-4 right-4 bg-primary text-background px-5 py-2.5 rounded-full text-sm font-semibold shadow-lg" data-id="element-145">
                  {service.price}
                </div>
              </div>
              <div className="p-8 flex flex-col flex-grow" data-id="element-146">
                <h3 className="text-2xl font-medium mb-3" data-id="element-147">{service.title}</h3>
                <p className="text-secondary leading-relaxed mb-8 flex-grow" data-id="element-148">
                  {service.description}
                </p>
                <a href="#contact" className="w-full py-4 bg-surface text-primary rounded-full font-medium border border-border hover:bg-primary hover:text-background transition-colors flex items-center justify-center gap-2" data-id="element-149">
                  Записатися <ArrowRight size={18} data-id="element-150" />
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}